import { takeLatest, put, call } from 'redux-saga/effects';
import { 
    FETCH_PARTNER_ORDERS_REQUEST,
    fetchPartnerOrdersResponse 
} from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS } from '../../constants'
import request from "../../components/Utils/httpHelper";

export function* fetchPartnerOrdersList(action) {
    let sortDir = (action.data.pageDescription.sorted.desc) ? "desc" : "asc";
    let requestURL = `${CORE_API}/v1/international/partner/orders/${action.data.pageDescription.skip}/${action.data.pageDescription.limit}/sort/${action.data.pageDescription.sorted.id}/${sortDir}`;
    try {
        const partnerOrders = yield call(request, requestURL, { data: action.data.requestBody, method: 'POST', headers: HTTP_HEADERS });
        yield put(fetchPartnerOrdersResponse(partnerOrders.data.results.data))
    }
    catch (err) {
        yield put(fetchPartnerOrdersResponse(err))
    }
}
export function* fetchPartnerOrders() {
    yield takeLatest(FETCH_PARTNER_ORDERS_REQUEST, fetchPartnerOrdersList);
}